export function formatUnreadCount(unreadCount: number) {
  if (unreadCount > 99) {
    return "99+";
  }

  return unreadCount.toString();
}
